module.exports = __webpack_public_path__ + "static/media/18ECA19.8c01a1e9.jpg";